var _line, _circle, _rect, _circle2, _circle3, _path, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSreAgentOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 2,
    x2: 11,
    y2: 4.5,
    stroke: "#4D99EF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 2,
    r: 0.9,
    fill: "#4D99EF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 4.5,
    width: 15,
    height: 13,
    rx: 2.8,
    ry: 2.8,
    stroke: "#4D99EF",
    strokeWidth: 1.4,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 10.5,
    r: 1.1,
    fill: "#4D99EF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10.5,
    r: 1.1,
    fill: "#4D99EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.5 H8 L9.2 13 L10.6 16 L12 14.5 H16.5",
    stroke: "#4D99EF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 17.5,
    x2: 6,
    y2: 19,
    stroke: "#4D99EF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 17.5,
    x2: 16,
    y2: 19,
    stroke: "#4D99EF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSreAgentOpen);
export default __webpack_public_path__ + "static/media/sre-agent-open.fbb52519d7bb38bb64c50da52aa31a02.svg";
export { ForwardRef as ReactComponent };